<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h2
            class="text-text-neutral-primary flex items-center gap-2 text-base font-medium"
          >
            <span class="text-lg leading-none" aria-hidden="true">✈️</span>
            {{ $t('recommendedOffers.title') }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton
            @click="hide"
          />
        </template>
      </FreeHeader>
    </template>
    <template #default="{ hide }">
      <div class="space-y-3 px-4 pb-8">
        <button
          v-for="(offer, offerIndex) in offers"
          :key="`${offer.search_query}-${offerIndex}`"
          type="button"
          class="block w-full text-left"
          @click="handleOfferClick(offerIndex, hide)"
        >
          <RecommendedOfferCard
            :offer="offer"
            :source="`recommendedOffers.bottomSheet.${offerIndex}`"
            :cashback-click-source="cashbackClickSource"
            @onCashbackClick="emit('onCashbackClick')"
          />
        </button>
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useRouter } from 'vue-router';
  import { FreeBottomSheet, FreeCloseButton, FreeHeader } from 'freedom-shared';

  import type { MappedRecommendedOffer } from '@/features/favorites';

  import { amplitudeEventsLib, type analyticsEventsLib } from '@/shared/lib';

  import { navigateToRecommendedOffer } from '../lib';
  import RecommendedOfferCard from './RecommendedOfferCard.vue';

  const props = defineProps<{
    name: string;
    offers: MappedRecommendedOffer[];
    cashbackClickSource: analyticsEventsLib.config.SearchResultCardCashbackPriceClickSource;
  }>();

  const emit = defineEmits<{
    onCashbackClick: [];
  }>();

  const router = useRouter();

  const handleOfferClick = (offerIndex: number, hide: () => void) => {
    const offer = props.offers[offerIndex];
    if (!offer) {
      return;
    }
    amplitudeEventsLib.recommendedOffersListItemClick({
      index: offerIndex,
      search_query: offer.search_query,
      offer_hash: offer.offerHash,
      origin_city_code: offer.origin.city.code,
      destination_city_code: offer.destination.city.code,
      price: offer.price?.amount,
      currency: offer.price?.currency,
    });
    hide();
    navigateToRecommendedOffer(router, offer);
  };
</script>
